/* src/app/components/submission-device-marketing/submission-device-marketing.component.scss */
/*# sourceMappingURL=submission-device-marketing.component.css.map */
